import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-thin",
  "use": "icon-arrow-thin-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill-rule=\"evenodd\" viewBox=\"0 0 24 24\" id=\"icon-arrow-thin\"><path d=\"m21.883 12-7.527 6.235L15 19l9-7.521L15 4l-.645.764L21.884 11H0v1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol